import styled from 'styled-components';

const SortByWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 4px;
  justify-content: flex-end;
`;

const SortByText = styled.div`
  width: 90px;
`;

export { SortByText, SortByWrapper };
